/**
 * Application version and build info
 * Update this with each deployment
 */
export const APP_VERSION = '2.1.0';
export const BUILD_DATE = '2026-03-03';
export const BUILD_ID = Date.now().toString(36);

export const getVersionInfo = () => ({
  version: APP_VERSION,
  buildDate: BUILD_DATE,
  buildId: BUILD_ID,
  fullVersion: `v${APP_VERSION} (${BUILD_DATE})`
});
